import { Brain } from "lucide-react";
import { MESSAGES } from "../constants";

interface LoadingStepProps {
  message: string;
}

export function LoadingStep({ message }: LoadingStepProps) {
  return (
    <div className="p-12 text-center">
      <div
        className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6"
        style={{ backgroundColor: "rgba(25, 103, 210, 0.1)" }}
      >
        <Brain
          className="w-8 h-8 animate-pulse"
          style={{ color: "var(--primary-color)" }}
        />
      </div>
      <h3
        className="text-xl font-bold mb-3"
        style={{ color: "var(--text-primary)" }}
      >
        Gerando sua aula...
      </h3>
      <p className="text-sm mb-6" style={{ color: "var(--text-tertiary)" }}>
        {message}
      </p>
      <div className="w-64 h-2 bg-(--bg-accent) rounded-full overflow-hidden mx-auto">
        <div
          className="h-full rounded-full"
          style={{
            width: "100%",
            background:
              "linear-gradient(90deg, #1967d2 0%, #4a8aff 50%, #1967d2 100%)",
            backgroundSize: "200% 100%",
            animation: "loading 2s ease-in-out infinite",
          }}
        ></div>
      </div>
      <style>
        {`
          @keyframes loading {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}
      </style>
      <p className="text-xs mt-4" style={{ color: "#9aa0a6" }}>
        {MESSAGES.LOADING_HINT}
      </p>
    </div>
  );
}
